import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { useTranslationApp } from "../../lib/i18next";
import {
  PRICING_CREDIT_USAGE_TITLE,
  CREDIT_COST_ITEM,
  PRICING_CREDIT_USAGE_CREDIT,
  PRICING_CREDIT_USAGE_CREDITS,
} from "../../i18n/keysTranslations";
import { useCreditActionCosts } from "../../hooks/useCreditActionCosts";

const CreditUsageInfo = () => {
  const { t } = useTranslationApp();
  const { creditCostsItems } = useCreditActionCosts();

  return (
    <Box
      sx={{
        maxWidth: "100%",
        mx: "auto",
        borderRadius: 2,
        bgcolor: "action.hover",
        px: 2,
      }}
    >
      <Typography
        variant="caption"
        sx={{
          display: "block",
          mb: 0.5,
          fontWeight: 600,
          textTransform: "uppercase",
          letterSpacing: "0.05em",
          color: "text.secondary",
          fontSize: "0.75rem",
          textAlign: "center",
        }}
      >
        {t(PRICING_CREDIT_USAGE_TITLE)}
      </Typography>
      <Box
        sx={{
          display: "flex",
          flexWrap: "wrap",
          alignItems: "center",
          justifyContent: "center",
          gap: {
            xs: 1,
            sm: 1.5,
          },
          fontSize: "0.75rem",
        }}
      >
        {creditCostsItems.map((item, index) => {
          const creditWord =
            item.credits === 1
              ? t(PRICING_CREDIT_USAGE_CREDIT)
              : t(PRICING_CREDIT_USAGE_CREDITS);

          return (
            <Box
              key={index}
              sx={{
                display: "flex",
                alignItems: "baseline",
                gap: 0.5,
              }}
            >
              {index > 0 && (
                <Typography
                  component="span"
                  sx={{
                    color: "text.secondary",
                    mx: {
                      xs: 0.5,
                      sm: 1,
                    },
                    display: {
                      xs: "none",
                      sm: "inline",
                    },
                  }}
                >
                  •
                </Typography>
              )}
              <Box
                sx={{
                  display: "flex",
                  alignItems: "baseline",
                  gap: 0.75,
                }}
              >
                <Typography
                  component="span"
                  sx={{
                    fontWeight: 700,
                    color: "text.primary",
                    fontSize: "0.75rem",
                  }}
                >
                  {t(CREDIT_COST_ITEM, {
                    credits: item.credits,
                    creditWord,
                    action: t(item.translationKey),
                  })}
                </Typography>
              </Box>
            </Box>
          );
        })}
      </Box>
    </Box>
  );
};

export default CreditUsageInfo;
